export enum EWebAccessType {
  reinsurance = 'R',
  sales = 'A',
  client = 'C',
  management = 'M',
  garrage = 'G',
  Bancassurance = 'B',
  coinsurance = 'I',
}
